import "core-js/modules/es.object.to-string";
import { ROUTE_NAME } from '@/lib/constant';
export default [{
  path: '/training_plan/',
  name: ROUTE_NAME.TRAINING_PLAN_INDEX,
  meta: {
    title: '训练计划',
    scrollBehavior: 'top',
    disableShare: true
  },
  component: function component() {
    return import(
    /* webpackChunkName: "training_plan" */
    './pages/index.vue');
  }
}, {
  path: '/training_plan/detail/:activityId',
  name: ROUTE_NAME.TRAINING_PLAN_DETAIL,
  meta: {
    title: '训练计划',
    scrollBehavior: 'top',
    disableShare: true
  },
  component: function component() {
    return import(
    /* webpackChunkName: "training_plan" */
    './pages/detail.vue');
  }
}, {
  path: '/training_plan/select/:activityId/:teamLevel/:currentLevel',
  name: ROUTE_NAME.TRAINING_PLAN_SELECT,
  meta: {
    title: '训练计划',
    scrollBehavior: 'top',
    disableShare: true
  },
  component: function component() {
    return import(
    /* webpackChunkName: "training_plan" */
    './pages/select.vue');
  }
}];